import * as React from "react";

import { Svg } from "../../../assets";
import { Card } from "semantic-ui-react";
import { cn } from "@/lib/utils";

interface Props {
  href?: string;
  title?: React.ReactNode | string;
  dateLabel?: string;
  thumbnail?: string;
  floatingIcon?: React.ReactNode | string;
  className?: string;
  disabled?: boolean;
  extra?: React.ReactNode;
  dataSkeleton?: boolean;
  onClick?: () => void;
}

const LibraryCard: React.FC<Props> = ({
  href,
  title,
  dateLabel,
  thumbnail,
  floatingIcon,
  className,
  disabled = false,
  extra,
  dataSkeleton = false,
  onClick,
}: Props) => {
  return (
    <Card
      className={cn(
        "bg-background rounded-lg border-border border shadow-none w-38 min-w-38 h-45 min-h-45 hover:shadow-md mx-0 my-2 overflow-hidden",
        className || "",
        disabled && "pointer-events-none opacity-50"
      )}
      data-skeleton={dataSkeleton}
      disabled={disabled}
      href={href}
      onClick={() => onClick?.()}
    >
      {floatingIcon && (
        <div className="absolute m-0 top-2 left-2 bg-transparent">
          {typeof floatingIcon === "string" ? <img className="size-8" src={floatingIcon} /> : floatingIcon}
        </div>
      )}
      <div className="h-full w-full bg-primary-foreground flex items-center justify-center overflow-hidden">
        <img
          src={thumbnail || Svg.PromptPlaceholder}
          alt="Library Card Thumbnail"
          className={cn("object-cover w-full h-full", !thumbnail && "object-contain")}
          style={{
            backgroundColor: "transparent",
          }}
        />
      </div>

      <Card.Content className="p-2.5">
        {title && (
          <Card.Header className="whitespace-nowrap text-ellipsis m-0 w-auto text-xs/4 text-foreground overflow-x-clip">
            {title}
          </Card.Header>
        )}
        {dateLabel && <Card.Description className="text-muted-foreground text-[10px]/3">{dateLabel}</Card.Description>}
      </Card.Content>
      {extra && (
        <Card.Content extra className="flex-auto grow-1 shrink-0 p-2.5">
          {extra}
        </Card.Content>
      )}
    </Card>
  );
};

export default LibraryCard;
